"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContract = createContract;
// ========================================
// CONTRACT UTILITIES (Pure Functions)
// ========================================
function extractPathParamNames(endpointPath) {
    const matches = endpointPath.match(/:(\w+)/g);
    return matches ? matches.map(match => match.slice(1)) : [];
}
function validateEndpointContract(contractName, endpointKey, endpoint) {
    const pathParams = extractPathParamNames(endpoint.path);
    if (pathParams.length === 0) {
        return;
    }
    if (endpoint.params === null) {
        throw new Error(`[Contract Validation] ${contractName}.${endpointKey} has path params (${pathParams.join(', ')}) in "${endpoint.path}" but params schema is null.`);
    }
}
function createContract(config) {
    Object.entries(config.endpoints).forEach(([endpointKey, endpoint]) => {
        validateEndpointContract(config.name, endpointKey, endpoint);
    });
    return config;
}
